import { UserIdData } from '$domain/model/user/user.model'

let userData: UserIdData = {
  id: '',
  name: '',
  email: '',
  caretakerId: '',
  hasActivePremiumSubscription: false,
  hasActiveProSubscription: false,
}

export const localUserIdData = {
  getUserIdData: () => userData,
  setUserIdData: (newUserData: UserIdData) => (userData = newUserData),
  unsetUserIdData: () =>
    (userData = {
      id: '',
      name: '',
      email: '',
      caretakerId: '',
      hasActivePremiumSubscription: false,
      hasActiveProSubscription: false,
    }),
}



// WEBPACK FOOTER //
// ./src/utils/services/saveUserIdDataService/saveUserIdDataService.ts